import {CREATE_REF_SUBSCRIBE_SYMBOL} from '../constants';

export default function subscribeToRef(ref, component, propertyName) {
	return ref && ref[CREATE_REF_SUBSCRIBE_SYMBOL](component, propertyName);
}
